export const environment = {
  production: false,
  apiURL: 'https://api.telxius.com/looking-glass/v1',
  recaptcha_public_key:'6Ld1SUMsAAAAAE0UCyieliOFLJA040qF1_IIt822'
};

